import { TaskStatus } from '@exam-management/graphql';
import { type LabelProps, Label, LabelColor } from '@shared/components';

interface TaskStatusTagProps extends LabelProps {
  status: TaskStatus;
  name: string;
}

const TASK_STATUS_COLOR = {
  [TaskStatus.Todo]: LabelColor.INFO,
  [TaskStatus.InProgress]: LabelColor.WARNING,
  [TaskStatus.Completed]: LabelColor.SUCCESS,
};

export default function TaskStatusTag(props: Readonly<TaskStatusTagProps>) {
  const { status, name, ...restProps } = props;
  return (
    <Label
      color={TASK_STATUS_COLOR[status]}
      variant='outlined'
      sx={(theme) => ({
        flexShrink: 0,
        p: theme.spacing(1, 3),
        maxHeight: '28px',
      })}
      size='large'
      {...restProps}
    >
      {name}
    </Label>
  );
}
